// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 762 ? "52271efe" : chunkId) + "." + {"157":"32f9745b3f19cbe6","240":"cb0e02bf72b56cd0","762":"bb697aec07b982e6"}[chunkId] + ".js";
};